import * as React from "react";
import * as ReactDOMClient from "react-dom/client";

import { LoginAndParentAccountCreationContainer } from "./components/LoginAndParentAccountCreationContainer";
import { FallbackError } from "shared/components/FallbackError";
import { ErrorBoundary } from "shared/components/ErrorBoundary";

declare const redirectUrl: string;
declare const countryIso: string;

const root = ReactDOMClient.createRoot(document.getElementById("login-root"));
root.render(
  <ErrorBoundary
    fallback={(props) => <FallbackError {...props} theme="light" showDetails />}
  >
    <LoginAndParentAccountCreationContainer
      redirectUrl={redirectUrl}
      countryIso={countryIso}
    />
  </ErrorBoundary>,
);
